import React from 'react';

import component from '../component';
import Link from '../Link';
import LinkButton from '../LinkButton';
import TopBanner from '../TopBanner';
import Banner from '../Banner';
import {NewsItemHome} from './News';
import {Tabs, Tab} from '../Tabs';
import {VBox, HBox} from '../Box';
import {Table, Tr, Th, Td} from '../Table';
import Flag from '../Flag';
import TournamentAnnouncement from '../TournamentAnnouncement';
import Games from '../Games';
import Api from '../../api';
import {ArrowRight} from '../icons';


const LinkToAll = component('LinkToAll', function({linkName, linkQuery, text}) {
  return (
    <div className='Home-LinkToAll'>
      <Link name={linkName} query={linkQuery}>
        {text}
      </Link>
      <ArrowRight className='Home-BestLinkArrow' />
    </div>
  )
});

const HomeNewsBanner = component('HomeNewsBanner', function({banner}) {
  return (
    <div className="Home-BannerContainer">
      <Banner data={banner} width={300} height={500} type='vertical' />
    </div>
  )
});

const NewsList = component('NewsList', function({data, news}) {
  let list = news.map((item,i) => <NewsItemHome data={item} key={i} />);

  let advert = null;

  if (data.getIn(['banners', 'main_side'])) {
    advert = <HomeNewsBanner banner={data.getIn(['banners', 'main_side'])} />

    let insertArrayAt = function(array, index, arrayToInsert) {
      Array.prototype.splice.apply(array, [index, 0, arrayToInsert]);
      return array;
    }

    if (list.count() > 3) {
      list = insertArrayAt(list.toJS(), 3, advert);
      advert = null;
    }
  }

  return (
    <div className='Home-NewsList'>
      {list}
      {advert}
    </div>
  )
});

export default component('Home', function({data, params}) {

  const tournaments = data.get('tournaments') && data.getIn(['tournaments', 'list']);
  const news = data.get('news') && data.getIn(['news', 'list']);

  return (
    <div>
      <TopBanner social background={data.getIn(['banners', 'main_top', 'image'])} size='large'>
      {
        data.getIn(['banners', 'main_top']) &&
        <Banner
          data={data.getIn(['banners', 'main_top'])}
          type='horizontal'
          imageType='logo'
        />
      }
      </TopBanner>
      <Games data={data.cursor('gamesRecent')} />
      <HBox width={4}>
        <VBox width={2}>
          {tournaments &&
            <HBox width={2}>
              <TournamentAnnouncement picPosition="top" description details data={tournaments.get(0)} />
            </HBox>
          }
          {tournaments &&
            <HBox width={2}>
              <VBox>
                <TournamentAnnouncement picPosition="top" description details={false} data={tournaments.get(1)} />
              </VBox>
              <VBox>
                <TournamentAnnouncement picPosition="top" description details={false} data={tournaments.get(2)} />
              </VBox>
            </HBox>
          }
          <HBox width={2}>
            <Tabs>
              <Tab header='Лучшие игроки'>
                <Table size='normal' >
                  <Tr>
                    <Th width='12%'></Th>
                    <Th width='5%'></Th>
                    <Th width='38%'>Имя</Th>
                    <Th width='30%'>Команда</Th>
                    <Th width='15%' align='right'>Очки</Th>
                  </Tr>
                  {data.getIn(['usersHomeTop', 'list']) && data.getIn(['usersHomeTop', 'list']).map((user, i) =>
                    <Tr key={i}>
                      <Td>{i + 1}</Td>
                      <Td><Flag country={user.get('country')} className='Home-TableFlag' /></Td>
                      <Td>
                        <Link name='playerDetails' params={{id: user.get('id')}}>
                          {user.get('nickname')}
                        </Link>
                      </Td>
                      <Td>
                        <Link name='teamDetails' params={{id: user.getIn(['team', 'id'])}}>
                          {user.getIn(['team', 'title'])}
                        </Link>
                      </Td>
                      <Td align='right'>{user.get('score')}</Td>
                    </Tr>
                  )}
                </Table>
                <LinkToAll linkName='players' linkQuery={{sort: '-score'}} text='Все игроки' />
              </Tab>
              <Tab header='Лучшие команды'>
                <Table size='normal'>
                  <Tr>
                    <Th width='12%'></Th>
                    <Th width='5%'></Th>
                    <Th width='68%'>Команда</Th>
                    <Th width='15%' align='right'>Очки</Th>
                  </Tr>
                  {data.getIn(['teamsHomeTop', 'list']) && data.getIn(['teamsHomeTop', 'list']).map((team, i) =>
                    <Tr key={i}>
                      <Td>{i + 1}</Td>
                      <Td><Flag country={team.get('country')} className='Home-TableFlag' /></Td>
                      <Td>
                        <Link name="teamDetails" params={{id: team.get('id')}}>
                          {team.get('title')}
                        </Link>
                      </Td>
                      <Td align='right'>{team.get('score')}</Td>
                    </Tr>
                  )}
                </Table>
                <LinkToAll linkName='teams' linkQuery={{sort: '-score'}} text='Все команды' />
              </Tab>
            </Tabs>
          </HBox>
        </VBox>
        <VBox width={2}>
          <Tabs>
            <Tab header='Новости'>
              {news &&
                <div>
                  <NewsList
                    news={news.slice(0, 5)}
                    data={data}
                  />
                  <LinkToAll linkName='newsHome' text='Все новости' />
                </div>
              }
            </Tab>
          </Tabs>
        </VBox>
      </HBox>
      <HBox width={4} isContainer={true}>
        <div className='Home-LogosTitle'>Наши партнеры</div>
      </HBox>
      <HBox width={4} isContainer={true}>
        <a href='http://paypal.com/' target='_blank'><div className='Home-LogoPaypal' /></a>
        <a href='http://youtube.com/' target='_blank'><div className='Home-LogoYoutube' /></a>
        <a href='http://twitter.com/' target='_blank'><div className='Home-LogoTwitter' /></a>
        <a href='http://google.com/' target='_blank'><div className='Home-LogoGoogle' /></a>
      </HBox>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/pages/Home.js